import React, { useMemo } from 'react';
import Collapse from '../../../../shared/ui/Collapse';
import Header from './Header';
import {
  createRoomRanges,
  extractNumbersFromStrings,
} from '../../../../shared/packages/address';
import GridLayout from '../../../../shared/ui/GridLayout';
import Column from './Column';
import { createPeriod } from '../../../../shared/packages/dateTime';
import { createAcceptanceSummary } from '../../../../shared/packages/acceptance';
import {
  useCurrentAcceptance,
  useCurrentAcceptanceHouseId,
} from '../../../../services/queries/acceptanceData';
import styles from './index.module.scss';

const { Panel } = Collapse;

const AcceptanceDetailsHeader = ({
  desksSlot,
  filterSlot,
  toggleViewSlot,
  massActionsSlot,
  ...props
}) => {
  const acceptance = useCurrentAcceptance();
  const houseId = useCurrentAcceptanceHouseId();

  const { title, summary } = useMemo(
    () => ({
      title: createTitle(acceptance, houseId),
      summary: createSummary(acceptance, houseId),
    }),
    [acceptance, houseId]
  );

  const { fromDate, toDate } = acceptance || {};

  return (
    <Panel
      {...props}
      header={
        <Header
          title={title}
          toggleViewSlot={toggleViewSlot}
          massActionsSlot={massActionsSlot}
        />
      }
    >
      <GridLayout minWidth="180px">
        <Column title="Интервал приема помещений">
          <ColText>{createPeriod(fromDate, toDate) ?? 'Нет данных'}</ColText>
        </Column>
        <Column title="Статус помещений">
          <ColText>{summary}</ColText>
        </Column>
        <Column title="Столы">{desksSlot || 'Нет данных'}</Column>
      </GridLayout>
      {filterSlot}
    </Panel>
  );
};

export default AcceptanceDetailsHeader;

function createTitle(acceptance, houseId) {
  if (houseId) {
    const flats = acceptance?.houses?.get(houseId)?.flats || [];
    return `Помещения ${createRoomRanges(extractNumbersFromStrings(flats))}`;
  }

  return acceptance?.name || '';
}

function createSummary(acceptance, houseId) {
  let acceptedCount = acceptance?.countAcceptanceAddresses;
  let total = acceptance?.countAddresses;

  if (houseId) {
    const houseInfo = acceptance?.houses?.get(houseId) || {};

    acceptedCount = houseInfo.countAcceptanceAddresses;
    total = houseInfo.countAddresses;
  }

  return createAcceptanceSummary(acceptedCount, total, { title: 'Принято' });
}

function ColText({ children }) {
  return <span className={styles.colText}>{children}</span>;
}
